module.exports = __webpack_public_path__ + "static/webbers-dd6eb249afec80b13b2b1ca70abec891.png";